import { changeHeaderTransform, changeTransform, confidenceTransform, confidenceHeaderTransform } from "lib/table/mediaTransforms.js";
import { addLineHeightTransform, threeLineClampTransform, sortChange, sortConfidence } from "lib/table/tableTransforms.js";

export const defaultSearchHeaders = [
	{
		name: "Search name",
		id: "name",
		width: 3,
		fixed: false,
		transform: addLineHeightTransform,
	},
	{
		name: "Query",
		id: "query",
		width: 3,
		fixed: false,
		disableSort: true,
		transform: threeLineClampTransform,
	},
];

export const predictSearchHeaders = [
	{
		name: "Query name",
		id: "name",
		width: 3,
		fixed: false,
		transform: addLineHeightTransform,
	},
	{
		name: "Location",
		id: "locationStr",
		width: 100,
		fixed: true,
	},
	{
		name: "Language",
		id: "lang",
		width: 100,
		fixed: true,
	},
	{
		name: "Immediate",
		id: "immediate",
		type: "prediction", // Used for local filtering
		width: 115,
		fixed: true,
		paddingLeft: 20,
		headerTransform: changeHeaderTransform,
		transform: changeTransform,
		sortColumn: sortChange,
	},
	{
		name: "Immediate Confidence",
		id: "immediate",
		type: "prediction", // Used for local filtering
		width: 60,
		fixed: true,
		headerTransform: confidenceHeaderTransform,
		transform: confidenceTransform,
		sortColumn: sortConfidence,
	},
	{
		name: "Short",
		id: "short",
		type: "prediction", // Used for local filtering
		width: 80,
		fixed: true,
		paddingLeft: 20,
		headerTransform: changeHeaderTransform,
		transform: changeTransform,
		sortColumn: sortChange,
	},
	{
		name: "Short Confidence",
		id: "short",
		type: "prediction", // Used for local filtering
		width: 60,
		fixed: true,
		headerTransform: confidenceHeaderTransform,
		transform: confidenceTransform,
		sortColumn: sortConfidence,
	},
	{
		name: "Medium",
		id: "mid",
		type: "prediction", // Used for local filtering
		width: 95,
		fixed: true,
		paddingLeft: 20,
		headerTransform: changeHeaderTransform,
		transform: changeTransform,
		sortColumn: sortChange,
	},
	{
		name: "Medium Confidence",
		id: "mid",
		type: "prediction", // Used for local filtering
		width: 60,
		fixed: true,
		headerTransform: confidenceHeaderTransform,
		transform: confidenceTransform,
		sortColumn: sortConfidence,
	},
	{
		name: "Long",
		id: "long",
		type: "prediction", // Used for local filtering
		width: 75,
		fixed: true,
		paddingLeft: 20,
		headerTransform: changeHeaderTransform,
		transform: changeTransform,
		sortColumn: sortChange,
	},
	{
		name: "Long Confidence",
		id: "long",
		type: "prediction", // Used for local filtering
		width: 60,
		fixed: true,
		headerTransform: confidenceHeaderTransform,
		transform: confidenceTransform,
		sortColumn: sortConfidence,
	},
];
